import React from 'react';
import Moment from 'react-moment';
import Markdown from 'react-markdown/with-html';

import {DevelopmentTicket} from '../Services/TicketService';

interface DevelopmentTicketPaneProps {
  ticket: DevelopmentTicket;
}

function DevelopmentTicketPane({ticket}: DevelopmentTicketPaneProps) {
  const divClass = "single-blog-post post-style-4 d-flex align-items-center";

  return (
    <div className={divClass}>
      <div className="post-content">
        <h5>
          <p className="headline">{ticket.ticketNumber} - {ticket.summary}</p>
        </h5>
        <Markdown
          source={ticket.releaseNote}
          escapeHtml={false}
          className="release-note"
        />
        <div className="post-meta">
          {ticket.version} - <Moment withTitle titleFormat="DD/MM/YYYY" fromNow local date={ticket.resolutionDate} />
        </div>
      </div>
    </div>
  );
}

export default DevelopmentTicketPane;
